import Marquee from "react-fast-marquee";
import { useLang } from "@/context/LanguageContext";

export const ValuesMarquee = () => {
  const { t } = useLang();
  const values = t("marquee");
  return (
    <div data-testid="values-marquee" className="bg-[#F8F9FA] border-y border-[#0A1128]/10 py-6 overflow-hidden">
      <Marquee speed={40} gradient={false} autoFill>
        {values.map((v, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display italic text-3xl md:text-5xl text-[#1D3557] px-8">{v}</span>
            <span className="text-[#D4AF37] text-2xl md:text-3xl">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};
